













import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GExamCreateFormFormat',
  computed: {},
  methods: {},
})
export default class GExamCreateFormFormat extends mixins(GPageBase) {
  @Prop() rowTitle: string;
  @Prop({ default: true }) isRequired: boolean;

  mounted() {}
}
